import rtkRequestStatusCodes from "../const/rtkRequestStatusCodes";
import { LoadingStatusCode } from "../types";

export const checkIsLoading = (...args: LoadingStatusCode[]) =>
  args.some((item) => item === rtkRequestStatusCodes.pending);

export const checkIsLoaded = (...args: LoadingStatusCode[]) =>
  args.every((item) => item === rtkRequestStatusCodes.fulfilled);

export const checkNotLoaded = (...args: LoadingStatusCode[]) =>
  !checkIsLoading(...args) && !checkIsLoaded(...args);
